/**
 * Created by Bob.Bao on 2017/12/18.
 */
import axios from 'axios'
import util from '@/util'
import app from '@/main'

let api = axios.create({
    baseURL: util.baseUrl + 'rest/api',
    headers: {'Content-Type': 'application/json'}
})

api.interceptors.request.use( config => {
    // 在发送请求之前做些什么
    config.headers.AuthorizationToken = window.sessionStorage.getItem('AuthorizationToken')
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
})
api.interceptors.response.use( res => {// 响应成功
    if(~res.data.message.indexOf('未登录')){
        app.$router.push(`/login?msg=${res.data.message}&redirect=${app.$route.fullPath}`)
    }
    return res
}, error => {
    alert('加载失败')
    return Promise.reject(error)
})
export default {
    getBids (data, cb, err) {
        axios.get('http://61.132.109.13:8090/private-rest/rest/forenotice/getForenotices', {
            params: data
            }).then((res) => {
                if (res.data.success) {
                    cb(res.data.returnValue)
                } else {
                    err(res.errorReason)
                }
          }, e => err(e))
    },
    getProvinces(data, cb, err){
        return api.get('/mDateApi/getProvince').then((res) => {
            if (res.data.result) {
                cb(res.data.value)
            } else {
                err(res.data.message)
            }
        }, e => err(e))
    },
    getApt(data, cb, err){
        return api.get('/mDateApi/getQualifications').then((res) => {
            if (res.data.result) {
                cb(res.data.value)
            } else {
                err(res.data.message)
            }
        }, e => err(e))
    },
    getCities(data, cb, err){
        return api.get(`/mDateApi/getCityByPro/${data}`, {
            params: data
        }).then((res) => {
            if (res.data.result) {
                cb(res.data.value)
            } else {
                err(res.data.message)
            }
        }, e => err(e))
    },
    getProductTypes(data, cb, err){
        return api.get('/mDateApi/getProducttype/').then((res) => {
            if (res.data.result) {
                cb(res.data.value)
            } else {
                err(res.data.message)
            }
        }, e => err(e))
    },

    getIsManagerLimit(param,managerlimit){
        api.get('/mDateApi/getManagerByProductTypeIds', {
            params:param
        }).then((res) => {
            if (res.data.result) {
                managerlimit = res.data.value.value
            }
        })
    },

    getCompanyTypes(data, cb, err){//获取供应商(公司)分类树形数据
        return api.get('/mDateApi/getCsspgroup/').then((res) => {
            if (res.data.result) {
                cb(res.data.value)
            } else {
                err(res.data.message)
            }
        }, e => err(e))
    },
    getContacts(data, cb, err){
        cb([])
    },
    getProjectManagers(data, cb, err){
        cb([])
    },
    submitForm (data, cb, err) {
        cb(data)
    },
    submitLogin(data, cb, err) {// 提交注册第一步
        cb(data)
    },
    submitRegister(data, cb, err) {
        if(data['serviceas']) delete data['serviceas'];
        let spss = [];
        if(data['spss']){
            spss = data['spss'].map(item=>{
                return {
                    cfremak: item.cfremak,
                    serviceaList: item.serviceaList,
                    linkOrder: item.linkOrder,
                    cfservicetypeid: item.cfservicetypeid
                }
            })
        }
        data['spss'] = spss;
        api.post('/dspUserApi/register', data).then((res) => {
            if (res.data.result) {
                cb(res.data.value)
            } else {
                err(res.data.message)
            }
        }, e => err(e))
    },
    updatePass(data){
        return api.post('/dspUserApi/changePwd', data)
    },
    updateSUserStock(data) {//基本信息
        return api.post('/dspUserApi/updateSUserStock', data)
    },
    checkCompanyName(name, cb, err){//检查供应商名称
        return api.get(`/dspUserApi/checkHasFnameL2/${name}`)
    },
    checkLoginName(name){//检查登录名称
        return api.get(`/dspUserApi/checkHasLName/${name}`)
    },
    checkPhone(phone){//检查手机号
        return api.get(`/dspUserApi/checkHasPhone/${phone}`)
    },
    checkPhoneCode(phone,code){//检查手机号
        return api.get(`/dspUserApi/checkSmsCode/${phone}/${code}`)
    },
    checkJoinPhone(phone){//检查手机号
        return api.get(`/dspUserApi/checkJoinPhone/${phone}`)
    },
    checkOtherApt(data){//检查资质是否过期
    	return api.post('/completeFourInfo/checkOutTimeApt', data)
    },
    getLittleStatus(stockId, hasYRZ, hasRKSPZ){
        let data={
            'id':stockId
        }
        return api.post('/completeFourInfo/checkLittleStatus', data).then((res) => {
            if(res.data.result){
                hasYRZ.flag = res.data.value.hasYRZ;
                hasRKSPZ.flag = res.data.value.hasRKSPZ
            }
        }, e => this.$alert(e))
    },
    checkLittleStatus(data){//检查供应商小状态
        return api.post('/completeFourInfo/checkLittleStatus', data)
    },
    checkSupplierZdIsNotCanEdit(stockId,type){//检查外网供应商修改信息的时候是否可修改（false-能操作，true-无法操作）
        let data={
            'id':stockId,
            'type':type
        }
        return api.post('/completeFourInfo/checkSupplierZdIsNotCanEdit', data)
    },
    getTeamChangeByContract(param){
        return api.post('/completeFourInfo/getTeamChangeByContract', param)
    },
    getContractBillsByStock(param){
        return api.post('/completeFourInfo/getContractBillsByStock', param)
    },
    getSmsCode(phone){
        return api.get(`/dspUserApi/getSmsCode/${phone}`)
    },
    addManager(data){//添加项目经理
        return api.post('/completeFourInfo/addManager', data)
    },
    addLinkPerson(data){//添加联系人
        return api.post('/completeFourInfo/addLinkPerson', data)
    },
    addServicea(data){//服务区域
        return api.post('/completeFourInfo/addServicea', data)
    },
    addSps(data){//专业类别
        return api.post('/completeFourInfo/addSps', data)
    },
    deleteManager(data){//编辑项目经理
        return api.delete('/completeFourInfo/deleteManager', data)
    },
    deleteLinkPerson(data){//编辑联系人
        return api.delete('/completeFourInfo/deleteLinkPerson', data)
    },
    deleteServicea(data){//服务区域
        return api.delete('/completeFourInfo/deleteServicea', data)
    },
    deleteSps(data){//专业类别
        return api.delete('/completeFourInfo/deleteSps', data)
    },
    editManager(data){//编辑项目经理
        return api.post('/completeFourInfo/editManager', data)
    },
    editLinkPerson(data){//编辑联系人
        return api.post('/completeFourInfo/editLinkPerson', data)
    },
    editServicea(data){//服务区域
        return api.post('/completeFourInfo/editServicea', data)
    },
    editSps(data){//专业类别
        return api.post('/completeFourInfo/editSps', data)
    },
    checkSUserStock(data){//审核基本信息
        return api.post('/checkUserInfo/updateSUserStock', data)
    },
    checkOtherInfo(data){//审核其他信息
        return api.post('/checkUserInfo/editOtherInfo/', data)
    },
    checkManagers(data){//审核项目经理
        return api.post('/checkUserInfo/editManager', data)
    },
    checkGysfjs(data){
        return api.post('/checkUserInfo/eidtGysfj', data)

    },
    checkLinkPersons(data){//审核联系人
        return api.post('/checkUserInfo/editLinkPerson', data)
    },
    checkServiceas(data){//审核服务区域
        return api.post('/checkUserInfo/editServicea', data)
    },
    checkSpss(data){//审核专业类别
        return api.post('/checkUserInfo/editSps', data)
    },
    getManager(id){//编辑项目经理
        return api.post('/completeFourInfo/getManagerDetail', id)
    },
    getLinkPerson(id){//编辑联系人
        return api.post('/completeFourInfo/getLinkPersonDetail', id)
    },
    getServicea(id){//服务区域
        return api.post('/completeFourInfo/getServiceaDetail', id)
    },
    getSps(id){//专业类别
        return api.post('/completeFourInfo/getSpsDetail', id)
    },
    getManagers(id){//编辑项目经理
        return api.post('/completeFourInfo/getManagersByStock', id)
    },
    getGysfjs(id){//承诺函
        return api.post('/completeFourInfo/getGysfj', {'id':id})
    },
    getLinkPersons(id){//编辑联系人
        return api.post('/completeFourInfo/getLinkPersons', id)
    },
    getServiceas(id){//服务区域
        return api.post('/completeFourInfo/getServiceasByStock', id)
    },
    getSpss(id){//专业类别
        return api.post('/completeFourInfo/getSpssByStock', id)
    },
    getLinksToSps(id){//专业负责人
        return api.post('/completeFourInfo/getLinksToSps', id)
    },
    getStockInfo(id){
        return api.post('/completeFourInfo/getStockInfoDetail', id)
    },
    getOtherInfo(id){
        return api.post('/completeFourInfo/getOtherInfo', id)
    },
    editOtherInfo(data){//其他信息
        return api.post('/completeFourInfo/editOtherInfo/', data)
    },
    getAuditRes(data){
        return api.post('/completeFourInfo/getAuditRes', data)
    },
    checkBindingSmsCode(phone,code){//检查
        return api.get(`/completeFourInfo/checkBindingSmsCode/${phone}/${code}`)
    },
    getBindingSmsCode(phone){
        return api.get(`/completeFourInfo/getBindingSmsCode/${phone}`)
    },
    checkUnBindingSmsCode(phone,code){//检查
        return api.get(`/completeFourInfo/checkUnBindingSmsCode/${phone}/${code}`)
    },
    getUnBindingSmsCode(phone){
        return api.get(`/completeFourInfo/getUnBindingSmsCode/${phone}`)
    },
    getStockStep(data){
        return api.post('/supplierHomepage/getStockStep', data)
    },
    checkDelManager(data){//检查登录名称
        return api.post('/checkUserInfo/checkDelManager', data)
    },
    getBankInfo(data){
        return api.post('/completeFourInfo/getBankInfo', data)
    },
    submitBankInfo(data){//提交银行信息的方法
        return api.post('/completeFourInfo/submitBankInfo', data)
    },
    getTeamChangeDetail(data){//根据合同查看团队详情
    	return api.post('/completeFourInfo/getTeamChangeDetail', data)
    },
    getManagerByContractId(data){//项目经理查询
    	return api.post('/completeFourInfo/getManagerByContractId', data)
    },
    changeManage(data){//变更项目经理
    	return api.post('/completeFourInfo/changeManage', data)
    },
    recallChangeManage(data){//撤回变更项目经理
    	return api.post('/completeFourInfo/recallChangeManage', data)
    },
    deleteRecallChangeManage(data){//删除撤回变更项目经理
    	return api.post('/completeFourInfo/deleteRecallChangeManage', data)
    },
}



// WEBPACK FOOTER //
// ./src/store/apis.js